import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import MemoryIcon from '@material-ui/icons/Memory';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import LockIcon from '@material-ui/icons/Lock';
import FolderIcon from '@material-ui/icons/Folder';
import PeopleIcon from '@material-ui/icons/People';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      const createNav = nav.take('page:scaffolder');
      const settingsNav = nav.take('page:user-settings');

      nav.take('page:app/llm-providers');
      nav.take('page:app/api-providers');
      nav.take('page:app/credentials');
      nav.take('page:app/projects');
      nav.take('page:app/users');
      nav.take('page:app/change-password');
      nav.take('page:catalog');
      nav.take('page:search');
      nav.take('page:home');
      nav.take('page:notifications');
      nav.take('page:app-visualizer');
      nav.take('page:techdocs');
      nav.take('page:api-docs');
      nav.take('page:catalog-graph');
      nav.take('page:catalog-import');
      nav.take('page:kubernetes');
      nav.rest();

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarDivider />
          <SidebarGroup label="Vault" icon={<MenuIcon />}>
            <SidebarItem icon={MemoryIcon} to="/" text="LLM Providers" />
            <SidebarItem
              icon={CloudQueueIcon}
              to="/api-providers"
              text="API Providers"
            />
            <SidebarItem icon={LockIcon} to="/credentials" text="Credentials" />
            <SidebarItem icon={FolderIcon} to="/projects" text="Projects" />
            {createNav}
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Account" icon={<PeopleIcon />}>
            <SidebarItem icon={PeopleIcon} to="/users" text="Users" />
            <SidebarItem
              icon={LockOpenIcon}
              to="/change-password"
              text="Change password"
            />
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {settingsNav}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
